<template>
  <ul
    :class="{
      'divide-y divide-white/10': variant === 'default',
    }"
  >
    <template v-for="(item, i) in destinations" :key="i">
      <template v-if="item.type === 'platform' && configExists(item)">
        <li
          :class="{
            'mb-4 overflow-hidden rounded-sm': variant === 'goLive',
          }"
          :key="i"
        >
          <DestinationListItemPlatform
            :destination="item"
            :variant="props.variant"
          />
        </li>
      </template>

      <template v-else-if="item.type === 'relay'">
        <li
          :key="i"
          :class="{
            'mb-4 overflow-hidden rounded-sm': variant === 'goLive',
          }"
        >
          <DestinationListItemRelay
            :destination="item"
            :variant="props.variant"
          />
        </li>
      </template>
    </template>
  </ul>
</template>

<script setup lang="ts">
const multistream = useMultistreamStore();
const props = defineProps<{ variant?: 'default' | 'goLive' }>();

const destinations = ref(
  props.variant !== 'goLive'
    ? multistream.destinations
    : multistream.destinations.filter(
        (destination) =>
          (destination.type === 'platform' && destination.is_connected) ||
          destination.type === 'relay',
      ),
);

const configExists = (destination: Destination) => {
  if (
    destination.type === 'platform' &&
    multistream.platformConfigs[destination.platform_type]
  ) {
    return true;
  }
  return false;
};

watch(
  () => multistream.destinations,
  (newValue) => {
    destinations.value =
      props.variant !== 'goLive'
        ? newValue
        : newValue.filter(
            (destination) =>
              (destination.type === 'platform' && destination.is_connected) ||
              destination.type === 'relay',
          );
  },
);
</script>
